<!--完善用户信息-->
<template>
  <div class="container_wang_check">
    <div class="inner_box">
      <div class="card">
        <p slot="title">
          完善用户信息
        </p>
      </div>
      <p class="title">请完善以下信息，通过平台审核后才能在本平台充值或提现</p>
      <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80" class="formCustom">
        <div style="display: flex;margin:0 auto;">
          <Form-item label="公司名称" prop="company" v-if="isCompany">
            <Input :model="formCustom.company" v-model="formCustom.company" placeholder="请输入公司名称"></Input>
          </Form-item>
          <Form-item label="公司法人" prop="legalPersonName" v-if="isCompany">
            <Input v-model="formCustom.legalPersonName" placeholder="请输入公司法人"></Input>
          </Form-item>
          <Form-item label="实际经营地" prop="realInstitute" v-if="isCompany">
            <Input v-model="formCustom.realInstitute" placeholder="请输入实际经营地"></Input>
          </Form-item>
        </div>
        <div style="display: flex;margin:0 auto;">
          <Form-item label="联系人" prop="linkName" v-if="isCompany">
            <Input v-model="formCustom.linkName" placeholder="请输入联系人姓名" :maxlength=10></Input>
          </Form-item>
          <Form-item label="用户姓名" prop="name" v-if="!isCompany">
            <Input v-model="formCustom.name" placeholder="请输入用户姓名"></Input>
          </Form-item>
          <Form-item label="联系电话" prop="linkPhone">
            <Input v-model="formCustom.linkPhone" placeholder="请输入联系电话" :maxlength=11></Input>
          </Form-item>
          <Form-item label="注册地址" prop="address" v-if="isCompany">
            <Input v-model="formCustom.address" placeholder="请输入地址" :maxlength=70></Input>
          </Form-item>
        </div>
        <div style="margin-left:40%;margin-top:20px;">
          <Form-item>
            <my-button @confirm="handleSubmit">提交</my-button>
          </Form-item>
        </div>
      </Form>
    </div>
    <loading></loading>
  </div>
</template>

<script>
  import ApiClient from "@/api/ApiClient";
  import MyButton from '@/components/MyButton'
  import loading from '@/components/loading'
  import uploadImg from '@/components/uploadImg'
  export default {
    name: "userInfo",
    components: {
      MyButton,
      loading,
      uploadImg
    },
    data() {
      const validateCompany = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('公司名称不能为空'));
        } else {
          callback();
        }
      };
      const validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('用户姓名不能为空'));
        } else {
          callback();
        }
      };
      const validateLinkName=(rule,value,callback)=>{
        if(value===''){
          callback(new Error('联系人不能为空'))
        }else{
          callback();
        }
      };
      const validateLinkPhone=(rule,value,callback)=>{
        if(value==''){
          callback(new Error('联系电话不能为空'))
        }else{
          callback();
        }
      };
      const validateAddress = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('地址不能为空'));
        } else {
          callback();
        }
      };
      const validateRealInstitute =(rule,value,callback)=>{
        if(value===''){
          callback(new Error ('实际经营地不能为空'))
        }else{
          callback();
        }
      };
      const validateLegalPersonName=(rule,value,callback)=>{
        if(value===''){
          callback(new Error('公司法人不能为空'))
        }else{
          callback();
        }
      };
      return {
        currentUser:{},
        isCompany:false,
        formCustom: {
          company: '',
          name: '',
          address: '',
          id: 0,
          linkName:'',
          linkPhone:'',
          accountType: 'company',
          legalPersonName:'',
          realInstitute:''
        },
        //验证规则
        ruleCustom: {
          company: [
            {validator: validateCompany, trigger: 'blur'}
          ],
          name: [
            {validator: validateName, trigger: 'blur'}
          ],
          realInstitute:[
            {validator:validateRealInstitute,trigger:'blur'}
          ],
          legalPersonName:[
            {validator:validateLegalPersonName,trigger:'blur'}
          ],
          address: [
            {validator: validateAddress, trigger: 'blur'}
          ],
          linkName:[
            {validator:validateLinkName,trigger:'blur'}
          ],
          linkPhone:[
            {validator:validateLinkPhone,trigger:'blur'}
          ],

        }
      }
    },
    methods: {
      handleSubmit() {
        if(this.isCompany){
          this.$refs.formCustom.validate((valid) => {
            if (valid) {
              ApiClient.post('/desktop/customer/add.do', {
                address: this.formCustom.address,
                company: this.formCustom.company,
                linkName:this.formCustom.linkName,
                linkPhone:this.formCustom.linkPhone,
                legalPersonName:this.formCustom.legalPersonName,
                realInstitute:this.formCustom.realInstitute
              }).then(data => {
                this.$router.push({
                  name: 'checkPending'
                })
              })
            } else {
              this.$Message.error('请完善信息');
            }
          })
        }else{
          this.$refs.formCustom.validate((valid) => {
            if (valid) {
              ApiClient.post('/desktop/customer/add.do', {
                name:this.formCustom.name,
                linkPhone:this.formCustom.linkPhone
              }).then(data => {
                this.$router.push({
                  name: 'checkPending'
                })
              })
            } else {
              this.$Message.error('请完善信息');
            }
          })
        }
      },
    },
    mounted(){
      this.currentUser = JSON.parse(window.sessionStorage.getItem('currentUser'));
      this.isCompany = (this.currentUser.accountType=='company');
    },
    computed: {
      loadingShow() {
        return this.$store.state.loadingShow
      }
    },
  }
</script>
<style scoped lang="less">
  .title {
    font-family: '微软雅黑';
    text-align: center;
    margin-top: 50px;
    font-size:15px;
  }

  .inner_box {
    width:95%;
    margin: 126px auto;
  }

  .card {
    width: 826px;
    border-bottom: #EAEAEA;
    font-size: 18px;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid rgba(234, 222, 225, 0.67);
    margin-top:-50px;
  }

  .formCustom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin:0 auto;
    margin-top:30px;
  }

  input::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 13px;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 13px;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 13px;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 13px;
  }
  /*表格*/
  .firstTable{
    border-collapse: collapse;
    width:95%;
    margin:0 auto;
    margin-top:15px;
  }
  .firstTable td {
    border: 1px solid #ccc;
    padding: 10px 18px;
    color: #525252;
    font-size: 15px;
  }
</style>
<style lang="less">
  .container_wang_check .ivu-input {
    width: 300px;
    height: 38px;
    padding-left: 16px;
    border-radius: 4px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/myProfile/userInfo.vue